import { apiLambda } from '../services/apiLambda';
import { REGISTER_ORIGIN } from '../utils/enums';
import { api } from '../services/api';
import { IDriver } from './useDriver';

const basePath = 'vehicle';

export interface IGetVehicleParams {
  placa: string;
  uf: string;
  email?: string;
  phone?: string;
  renavam?: string;
}

interface IGetVehicle {
  ano: string;
  id: number;
  marca: string;
  uf: string;
  renavam: number;
  tipo: string;
  placa?: string;
}
interface IGetVehicleByPlate {
  chassiRequired: boolean;
  documentRequired: boolean;
  ufRequired: boolean;
  vehicle: IGetVehicle;
}

export interface IUserVehicle {
  id?: number;
  idVehicle: number;
  document: string;
  nickname?: string;
  renavam: string;
  chassi?: string;
  uf: string;
  isSpecial?: boolean;
  general?: any;
  performance?: any;
  differentials?: any;
  modifications?: any;
  venalValue?: number;
  color: string;
  fuelType: string;
  owner: string;
  model: string;
  modelYear: number;
  vehicle?: IGetVehicle;
  driver?: IDriver;
  driverId?: number;
  showNotification: boolean;
  origin?: REGISTER_ORIGIN;
}

export const getVehicle = async ({
  placa,
  uf,
  email,
  renavam,
}: IGetVehicleParams): Promise<IGetVehicleByPlate> => {
  const { data } = await apiLambda.get(`/frotas/vehicle/${placa}`, {
    params: {
      uf,
      email,
      renavam,
    },
  });
  return data;
};

export const postVehicle = async (
  vehicle: IUserVehicle,
): Promise<IUserVehicle> => {
  const { data } = await api.post(`/${basePath}`, vehicle);
  return data['data']['userVehicle'] as IUserVehicle;
};

export const putVehicle = async (
  idUserVehicle: number,
  vehicle: IUserVehicle,
): Promise<void> => {
  return await api.put(`/user-vehicle/edit/${idUserVehicle}`, vehicle);
};

export const getUserVehicleById = async (id: number): Promise<IUserVehicle> => {
  const { data } = await api.get(`/user-vehicle/${id}`);
  return data['data']['user_vehicle'] as IUserVehicle;
};

export const deleteUserVehicle = async (id: number): Promise<void> => {
  return await api.delete(`/vehicle-user/${id}`);
};
